export default {
  title: {
    id: 'express_replacement_shipping_title',
    defaultMessage: 'Confirm your delivery info',
  },
  shippingAddressTitle: {
    id: 'express_replacement_shipping_shipping_address_title',
    defaultMessage: 'Shipping address',
  },
  infoBlockTitle: {
    id: 'express_replacement_shipping_info_block_title',
    defaultMessage: 'Need to ship to a different address?',
  },
  infoBlockContent: {
    id: 'express_replacement_shipping_info_block_content',
    defaultMessage:
      'For fraud protection, we can only send your replacement to the same address as your original order.',
  },
  infoBlockCta: {
    id: 'express_replacement_shipping_info_block_cta',
    defaultMessage: 'See other options',
  },
  deliveryOptionTitle: {
    id: 'express_replacement_shipping_delivery_option_title',
    defaultMessage: 'Delivery option',
  },
  continueCta: {
    id: 'express_replacement_shipping_continue_cta',
    defaultMessage: 'Continue',
  },
  dataPolicy: {
    id: 'express_replacement_shipping_data_policy',
    defaultMessage:
      'All data needed to process Express Replacement, meet legal requirements, and for fraud protection, is collected and managed by Back Market, the Seller and our payment provider. To find out more and exercise your data protection rights, see our {link, html}',
  },
  dataPolicyLink: {
    id: 'express_replacement_shipping_data_policy_link',
    defaultMessage: 'data protection policy.',
  },
}
